import React, { ReactElement } from 'react';

export default function NoData(): ReactElement {
  return <div>اطلاعاتی برای نمایش وجود ندارد</div>;
}
